import { useCallback, useState } from 'react';
import { parseDateFields } from '../../hooks/http/useHttpFetch';
import { guardedPut } from '../../api/guardedPut';
import { FetchError } from '../../api/api';

export interface FormEntityUpsertDto {
  formTemplateId: number;
  version: number;
  statePath: string;
  data: any;
  isFinal: boolean;
  /**
   * duration in minutes spent on form state.
   */
  duration: number;
}

export function useUpsertFormEntityData(tableName: string) {
  const [upsertedEntityData, setUpsertedEntityData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<FetchError>();

  const upsertEntityData = useCallback(
    async (formEntityUpsertDto: FormEntityUpsertDto) => {
      setLoading(true);
      // guardedPut owns retries and never rejects — a timeout, network drop,
      // or non-JSON body surfaces as an error state instead of escaping the
      // hook and leaving the submit spinner stuck (CHLOE-MOBILE-APP-11)
      try {
        const { json, error } = await guardedPut(
          `forms/entities/${tableName}`,
          formEntityUpsertDto
        );
        if (error) {
          setUpsertedEntityData(undefined);
          setError(error);
        } else {
          setError(undefined); // a successful resubmit must clear a prior failure
          setUpsertedEntityData(json ? parseDateFields(json) : json);
        }
      } finally {
        // even an unexpected parse throw must never leave the spinner stuck
        setLoading(false);
      }
    },
    [tableName]
  );

  return {
    upsertedEntityData,
    isUpsertingData: loading,
    upsertingDataError: error,
    upsertEntityData
  };
}
